import React from 'react'
import { useGetHTGIncentivePoint } from '../../api/point'
import { MultiCompaniesPointDetails } from '../shared/MultiCompaniesPointDetails'
import { TargetSummary } from './TargetSummary'
import { PointBreakdown } from './PointBreakdown'
import { Chip } from '@mui/material'

export const HTGIncentivePoint = () => {
  return (
    <>
      <MultiCompaniesPointDetails
        title='HTG Incentive Point'
        useGetPoint={useGetHTGIncentivePoint}
        backLink='htg-incentive-point'
        accountSummary={[
          {
            label: 'Company Name',
            id: 'companyName'
          },
          { id: 'primarySalesId', label: 'Primary Sales Id' },
          {
            id: 'bonusEnabled',
            label: 'Bonus',
            view: ({ bonusEnabled }) => (
              <Chip
                label={bonusEnabled ? 'Enabled' : 'Disabled'}
                size='small'
                color={bonusEnabled ? 'success' : 'default'}
              />
            )
          },
          {
            id: 'salesIds',
            label: 'Sales Ids',
            view: ({ salesIds = [] }) => salesIds.map((id) => <div key={id}>{id}</div>)
          },
          {
            id: 'details',
            label: 'Point Breakdown',
            view: ({ pointBreakdown }) => <PointBreakdown pointBreakdown={pointBreakdown} />
          },
          {
            id: 'targetSummary',
            label: 'Target',
            view: ({ targetSummary }) => <TargetSummary targetSummary={targetSummary} />
          },
          { id: 'type', label: 'Type' },
          { id: 'point', label: 'Total Points' }
        ]}
      />
    </>
  )
}
